// TODO: remove css loading class when HORIZON_ENABLED removed (aka migration completed)
export const quillWrapperCssLoadingClass = 'quill-wrapper-css-loading';
